// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"6de9b3d8","207":"6de9b3d8","543":"6de9b3d8","572":"6de9b3d8","682":"6de9b3d8","699":"6de9b3d8","818":"6de9b3d8","820":"6de9b3d8"}[chunkId] + ".chunk.css";
};